export default __webpack_public_path__ + "static/media/ThinkOverseasTravel.e34cfdae17f543ce02633dfd506d4f3e.webp";